import * as React from "react";
import { useWaMembershipFormContext } from "./WaMembershipFormContext";

const ThankYouStep: React.FC = () => {
    const formContext = useWaMembershipFormContext();

    return (
        <div className="container">
            <div className="justify-content-center">
                <h1 className={"donFormHeader donOpposite" + formContext.colorTheme}>Thank you, your form has been submitted.</h1>
            </div>
         </div>
    );
}

export default ThankYouStep;